import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCoButtonDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" d="M1 2h3V0h8v2h3v2H1z" />
    <path fill="#616061" fillRule="evenodd" d="M13 6H3v10h10z" clipRule="evenodd" />
  </svg>
);
export default SvgCoButtonDelete;
